import { useDisclosure } from '@chakra-ui/react';
import { useAvailableLocale } from 'hooks/localisation/useAvailableLocale';
import { useGlobals } from 'hooks/useGlobals';
import {
  useLocalStorage,
  UserLocale,
  UserLocalePreference,
} from 'hooks/userPreferences';
import {
  DEFAULT_COUNTRY_CODE,
  DEFAULT_LOCALE_INFO,
} from 'lib/constants/siteDefaults';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useCookie } from 'react-use';

export const useCountryModal = () => {
  const { data: globals } = useGlobals();
  const [usersCountryCode] = useCookie('countryCode');
  const router = useRouter();

  const { setStoredValue: setUserSiteLocale, isLoading: isLocaleLoading } =
    useLocalStorage(UserLocale);

  const {
    value: userLocalePreference,
    setStoredValue: setUserLocalePreference,
    isLoading: isPreferenceLoading,
  } = useLocalStorage(UserLocalePreference);

  const { hasSetLocale: userHasSetLocale } = userLocalePreference;
  const isLoading = isLocaleLoading || isPreferenceLoading;

  const {
    isOpen: isCountryModalOpen,
    onOpen: onOpenCountryModal,
    onClose: onCloseCountryModal,
  } = useDisclosure();
  const { getAvailableLocale } = useAvailableLocale();

  useEffect(() => {
    if (!globals || !usersCountryCode || isLoading) return;
    if (
      !getAvailableLocale(usersCountryCode) ||
      usersCountryCode === DEFAULT_COUNTRY_CODE
    ) {
      return;
    }

    if (userHasSetLocale === false) {
      onOpenCountryModal();
    } else {
      onCloseCountryModal();
    }
  }, [
    globals,
    isLoading,
    onOpenCountryModal,
    onCloseCountryModal,
    usersCountryCode,
    userHasSetLocale,
    getAvailableLocale,
  ]);

  const usersLocale =
    getAvailableLocale(usersCountryCode) || DEFAULT_LOCALE_INFO;

  const handleCountryModalClose = () => {
    setUserSiteLocale(DEFAULT_LOCALE_INFO);
    setUserLocalePreference({ hasSetLocale: true });
    onCloseCountryModal();
  };

  const handleCountryModalAccept = () => {
    setUserSiteLocale(usersLocale);
    setUserLocalePreference({ hasSetLocale: true });
    router.reload();
  };

  const handleCountryModalStay = () => {
    setUserSiteLocale(DEFAULT_LOCALE_INFO);
    setUserLocalePreference({ hasSetLocale: true });
  };

  return {
    isCountryModalOpen,
    onOpenCountryModal,
    onCloseCountryModal: handleCountryModalClose,
    handleCountryModalAccept,
    handleCountryModalStay,
    usersLocale,
  };
};
